import { TipCard } from './TipCard';
import { BannerCard } from './BannerCard';
import { TipCardConfig } from '../types/tipcard';

interface UnifiedTipCardProps {
  config: TipCardConfig;
  variant?: 'card' | 'list';
  onDismiss?: (id: string) => void;
  isFirstInSection?: boolean;
}

/**
 * UnifiedTipCard - Renders either a TipCard or BannerCard based on config
 * Ensures consistent behavior and placement across Classic and Compact views
 */
export function UnifiedTipCard({ config, variant = 'card', onDismiss, isFirstInSection = false }: UnifiedTipCardProps) {
  if (!config.enabled) {
    return null;
  }

  if (config.type === 'banner') {
    return (
      <BannerCard
        id={config.id}
        text={config.text}
        ctaLabel={config.ctaLabel}
        bannerImageUrl={config.bannerImageUrl || ''}
        bannerOverlayOpacity={config.bannerOverlayOpacity}
        ctaLink={config.ctaLink}
        variant={variant}
        onDismiss={onDismiss}
        isFirstInSection={isFirstInSection}
      />
    );
  }

  // Standard TipCard
  return (
    <TipCard
      id={config.id}
      variant={variant}
      onDismiss={onDismiss}
      config={config}
      isFirstInSection={isFirstInSection}
    />
  );
}